import { authenticatedDelete } from '../../../../../../api/request';

export default async function deleteLanguageInProfile(idDoctorUser, idLanguage, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error agregando el lenguaje a su perfil.');
    const url = `/doctor-profile-management/language/${idLanguage}/doctor-user/${idDoctorUser}`;
    return await authenticatedDelete(url, onFail);
}
